import { CommunicatorService } from 'ui-ng-component-communicator';
import { IApplicationConfiguration } from '../../../models/app_config_model';
import { UserModesService } from '../../../user_modes/user_modes_service';
import { AccountModel } from 'data-ng-authentication';
import { ICommand } from 'core-ts-types';
export class AppHeaderController {
  private productHeader: string;
  private institutionName: string;
  private isStudentPreview: boolean;
  private defaultStateContext: string;
  private isUserModeStudent: boolean;
  constructor(
    private DefaultRoute: any,
    private $state: ng.ui.IStateService,
    private appConfigModel: IApplicationConfiguration,
    private ngUserModesService: UserModesService,
    private $location: ng.ILocationService,
    private ngComponentCommunicatorService: CommunicatorService,
    private openOpenableElementCommand: ICommand,
    private accountModel: AccountModel,
    private stopImpersonationCommand: any,
    private log: any
  ) {}

  $onInit() {
    this.productHeader = `${this.appConfigModel.productName().toLowerCase()}-header`;
    this.institutionName = this.appConfigModel.getConfigProperty('core-inst_name');
    this.isStudentPreview = this.ngUserModesService.isStudentPreview;
    this.isUserModeStudent =
      this.ngUserModesService.isUserModeStudent ||
      window.location.href.includes('/#/my') ||
      window.location.href.includes('/#/dl');
    this.defaultStateContext = this.$state.is('poll') ? `poll` : this.DefaultRoute;
  }

  goHome = () => {
    this.$state.go(this.DefaultRoute);
  };

  openHelp() {
    this.openOpenableElementCommand('appSupportDrawer');
  }

  showHelpButton(): boolean {
    return this.$location.url().search(/authentication/) === -1 && this.isUserModeStudent;
  }

  stopImpersonation() {
    this.stopImpersonationCommand()
      .then(() => {
        window.open(`/content`, '_self');
        this.log.user.success(`You stopped impersonating ${this.accountModel.fullname}.`);
      })
      .catch((error: any) => {
        this.log.error(error);
      });
  }
}

export class AppHeaderComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/header/components/app_header/app_header.html';
  public controller: any = AppHeaderController;
  public transclude: boolean = true;
}



// WEBPACK FOOTER //
// ./app/lib/header/components/app_header/app_header.ts